import ds from './DataSourceService'

const baseUrl = '/items'

const getPackageItemsById = itemId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + itemId)
}

const createPackageItem = itemId => {
  return ds.apiClientThinkHome.post(baseUrl, itemId)
}

const updatePackageItem = item => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + item.id, item)
}

const deletePackageItem = projectPackageId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + projectPackageId)
}

export default {
  getPackageItemsById,
  createPackageItem,
  updatePackageItem,
  deletePackageItem
}
